import { Component, NgModule, ViewContainerRef } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { FieldDataUpsertOperationInterface } from '@vendasta/account-group';
import { FieldHandler, FieldHandlerValidator } from '../auxiliary-data-table/auxiliary-data-table.interface';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

export class NotYetSupportedHandler implements FieldHandler {
  fieldId: string;
  name: string;
  label: string;
  value: any;
  description: string;
  formControl: UntypedFormControl;
  validators?: FieldHandlerValidator[];
  readOnly?: boolean;

  constructor() {
    this.formControl = new UntypedFormControl();
    this.formControl.setValidators(() => ({ notYetSupported: true }));
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    viewContainerRef.createComponent<NotYetSupportedComponent>(NotYetSupportedComponent);
  }

  upsertOperation(): FieldDataUpsertOperationInterface {
    throw new Error('Method not implemented.');
  }

  hasModification(): boolean {
    return false;
  }
}

@Component({
  styles: [
    `
      #text {
        margin: 0 5px;
        padding: 6px 0 8px;
      }
    `,
  ],
  template: `
    <div id="text" class="value">
      {{ 'FIELD_NOT_YET_SUPPORTED' | translate }}
    </div>
  `,
  standalone: false,
})
export class NotYetSupportedComponent {}

@NgModule({
  declarations: [NotYetSupportedComponent],
  exports: [NotYetSupportedComponent],
  imports: [CommonModule, MatInputModule, ReactiveFormsModule, TranslateModule, GalaxyFormFieldModule],
})
export class NotYetSupportedComponentModule {}
